import { unlocalizeRouteName } from '@marketplace/helpers/router.js'
import Cookies from 'js-cookie'

const discoveryPath = []
let discoveryAttributes = []
let discoveryQuery = []
let discoveryCategoryLevel = []
let productPageViewCount = 0
const locale = window?.Store?.locale

const savedPath = Cookies.get('discovery_path')
const savedQuery = Cookies.get('discovery_query')

const validPrefixesSearch = [
    '/account/',
    '/inbox',
    '/marketplace',
    '/listings',
    '/page',
    '/search',
]
if (
    validPrefixesSearch.some((prefix) => savedPath?.includes(prefix)) ||
    savedPath === '/'
) {
    // Special for twig account pages and cart.
    discoveryPath.push(savedPath)
}

if (savedPath?.includes('/search')) {
    discoveryQuery.push(savedQuery)
}

export const trackSource = (to, from) => {
    const routeName = unlocalizeRouteName(to.name)

    if (!routeName) {
        return
    }

    if (routeName === 'product') {
        productPageViewCount++

        if (
            discoveryPath.length === 0 ||
            typeof discoveryPath === 'undefined'
        ) {
            discoveryPath.push('direct')
        } else if (productPageViewCount > 1) {
            discoveryPath.push(replaceLocale(from.fullPath))
            clearDiscoveryData()
        }
    } else if (
        !routeName.includes('storefront') &&
        !routeName.includes('cart')
    ) {
        clearDiscoveryData()
        productPageViewCount = 0

        if (routeName === 'marketplace' || routeName === 'productsearch') {
            discoveryCategoryLevel.push(window?.Store?.currentCategoryDepth)
        }

        if (routeName === 'search') {
            discoveryQuery.push(to.query.search)
        }

        if (to.fullPath.includes('?')) {
            const path = to.fullPath.split('?')
            discoveryPath.push(replaceLocale(path[0]))
            discoveryAttributes.push(path[1])
        } else {
            routeName.includes('home')
                ? discoveryPath.push('/')
                : discoveryPath.push(replaceLocale(to.fullPath))
        }
    } else if (routeName.includes('storefront') || routeName.includes('cart')) {
        productPageViewCount = 0
    }

    setOrRemoveSourceCookie('discovery_path', discoveryPath)
    setOrRemoveSourceCookie('discovery_attributes', discoveryAttributes)
    setOrRemoveSourceCookie('discovery_query', discoveryQuery)
    setOrRemoveSourceCookie('discovery_category_level', discoveryCategoryLevel)
}

const setOrRemoveSourceCookie = (name, content) => {
    const inThirtyMinutes = new Date(new Date().getTime() + 30 * 60 * 1000)

    if (!content?.length) {
        Cookies.remove(name)

        return
    }

    Cookies.set(name, content[content.length - 1], {
        expires: inThirtyMinutes,
    })
}

const clearDiscoveryData = () => {
    discoveryAttributes = []
    discoveryQuery = []
    discoveryCategoryLevel = []
}

const replaceLocale = (path) => {
    return path.includes(locale) ? path.replace(`/${locale}/`, '/') : path
}
